import { Row, Col, Form, Button, Modal } from 'react-bootstrap';
import "./AssignTechnicalModal.css"
import {  useState } from 'react';
import Swal from "sweetalert2";

//LOG FUNCTION
import { storeOrderLog } from "../../Helper_Library.js";

const AssignTechnicalModal = ({ show, requestClose, orderID }) => {

    //ENV VARIABLE
    const apiUrl = process.env.REACT_APP_API_URL;
    const backendAPI_Key = process.env.REACT_APP_API_KEY;

    //SESSION OBJECT
    const sessionUser = JSON.parse(sessionStorage.getItem("userSession"));

    //INPUTS CONTROLS
    const [technicalName, setTechnicalName] = useState(null);
    const [serviceInvoice, setServiceInvoice] = useState(null);
    
    const [objOrder, setObjOrder] = useState([]);
    const [userTechnicalListing, setUserTechnicalListing] = useState([]);

    const requestOrderInfo = async () =>{

        //
        let endpoint = "getOrderByID?order_id=" + orderID;


        let response = await fetch(apiUrl + endpoint,
        {
            method: "GET",
            headers: {"Content-Type": "application/json" , "X-API-KEY" : backendAPI_Key}
        });

        let responseContent = await response.json();

        let metadata = JSON.parse(responseContent.metadata);
        setObjOrder(metadata);



        //GET USERS
        endpoint = "getUsersListing";


        response = await fetch(apiUrl + endpoint,
        {
            method: "GET",
            headers: {"Content-Type": "application/json", "X-API-KEY" : backendAPI_Key}
        });

        responseContent = await response.json();
        setUserTechnicalListing(responseContent);


    } //END FUNCTION


    const assignTechnical = async () => {


        //MAIN VALIDATION
        if(!technicalName || !serviceInvoice){

            //Show message sweet alert
            Swal.fire({
                title: "Datos Faltantes",
                text: "Faltan datos obligatorios por completar.",
                icon: "warning",
                confirmButtonText: "OK"
            });

            return;
        }//

        const endpoint = "updateOrder?orderID=" + orderID;


        //
        const metadata = {
            "customer": objOrder.customer,
            "model": objOrder.model,
            "serialNumber":objOrder.serialNumber,
            "failure":objOrder.failure,
            "personContact":objOrder.personContact,
            "issuesDate": objOrder.issuesDate,
            "status": "Técnico asignado",
            "address": objOrder.address,
            "tecnico": technicalName,
            "serviceInvoice": serviceInvoice,
            "personContactData": objOrder.personContactData,
            "notes": objOrder.notes,
            
        };

        //
        const requestBody ="{\"metadata\":\"" + JSON.stringify(metadata).replace(/"/g, '\\"') + "\"}";

        //
        await fetch(apiUrl + endpoint,
        {
            method: "POST",
            headers: {"Content-Type": "application/json", "X-API-KEY" : backendAPI_Key},
            body: requestBody
        });

        //Show message sweet alert
        Swal.fire({
            title: "¡Éxito!",
            text: "Operación realizada exitosamente.",
            icon: "success",
            confirmButtonText: "OK"
        });


        //STORE LOG INFORMATION
        storeOrderLog(orderID, sessionUser.customer_name, "Técnico Asignado a Servicio", "Se asignó el técnico: " +  technicalName );

        //CLOSE MODAL
        requestClose(false);


    } //END FUNCTION

    return (
        <>
        <Modal show={show} onShow={requestOrderInfo}  onHide={requestClose} className={'mainOrderModal'}>
            <Modal.Header closeButton style={{borderTop:'10px solid #404661'}}>
                <Modal.Title className={'newOrderTitle'}>Asignar Técnico a la Orden de Servicio | <b style={{color:"darkred"}}>N° {orderID}</b></Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                <Row>
                    <Col xs={12} style={{lineHeight: '20px'}}>
                        
                        <span className='closeOrderlabels'>Cliente: </span>
                        <span>{objOrder.customer} </span><br />
                        
                        <span className='closeOrderlabels'>Modelo: </span>
                        <span>{objOrder.model} </span><br />

                        <span className='closeOrderlabels'>N° Serie: </span>
                        <span>{objOrder.serialNumber}</span><br />

                        <span className='closeOrderlabels'>Falla: </span>
                        <span>{objOrder.failure}</span><br />

                        <span className='closeOrderlabels'>Persona Contacto: </span>
                        <span>{objOrder.personContact}</span><br />

                        <span className='closeOrderlabels'>Dirección del servicio: </span>
                        <span>{objOrder.address}</span><br />

                        <span className='closeOrderlabels'>Datos de Contacto: </span>
                        <span>{objOrder.personContactData}</span><br />

                        <span className='closeOrderlabels'>Notas / Observaciones: </span>
                        <span>{objOrder.notes}</span><br />

                        <hr />
                        <span className='closeOrderlabels'>Servicio Facturable: </span>
                        <span>
                            <Form.Select style={{fontSize:"14px"}} onChange={(e)=>{setServiceInvoice(e.target.value); }} >
                                <option style={{fontSize:"14px"}}>Seleccione...</option>
                                <option style={{fontSize:"14px"}}>No</option>
                                <option style={{fontSize:"14px"}}>Si</option>
                            </Form.Select>
                        </span>
                        <br />

                    </Col>
                    <hr />
                    
                    <Col xs={12}>
                        <Form.Group>
                             <Form.Label className='closeOrderlabels'>Listado de Técnicos</Form.Label>
                             <Form.Select style={{fontSize:"14px"}} onChange={(e)=>{setTechnicalName(e.target.value); }} >
                                <option style={{fontSize:"14px"}}>Seleccione...</option>
                                {userTechnicalListing.map((item)=>{

                                    return(
                                        (item.groupname === "Técnicos" ? (
                                            <option style={{fontSize:"14px"}}>{item.customer_name}</option>
                                        ) : "" )
                                    )

                                })}
    
                            </Form.Select> <br />
                        </Form.Group>
                    </Col>
                </Row>
                </Form>
            </Modal.Body>
            <Modal.Footer>
            <Button variant="danger" onClick={requestClose} size='sm'>
                Cerrar Ventana
            </Button>
            <Button 
                variant="success" 
                size='sm'
                onClick={assignTechnical}
                >

                Guardar Datos
            </Button>
            </Modal.Footer>
        </Modal>
        </>
    );
}

export default AssignTechnicalModal;